<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="280"
    height="178"
    viewBox="0 0 280 178"
  >
    <g fill="none" fill-rule="evenodd">
      <path fill="#E4FF18" d="M199 160c0 3.866-26.415 7-59 7s-59-3.134-59-7 26.415-7 59-7 59 3.134 59 7" opacity=".3" />
      <g stroke="#CBCBD4" stroke-linecap="round" stroke-width="2">
        <path d="M94.5 18v5M77 35.5h5M82.126 23.126l3.535 3.535M82.126 47.874l3.535-3.535" />
      </g>
      <path
        fill="#FFF"
        d="M96 142c-2.205 0-4-1.794-4-4V37c0-2.206 1.795-4 4-4h88c2.206 0 4 1.794 4 4v101c0 2.206-1.794 4-4 4H96z"
      />
      <path
        fill="#CBCBD4"
        d="M184 32H96a5 5 0 0 0-5 5v101a5 5 0 0 0 5 5h88a5 5 0 0 0 5-5V37a5 5 0 0 0-5-5m0 2c1.654 0 3 1.346 3 3v101c0 1.654-1.346 3-3 3H96c-1.655 0-3-1.346-3-3V37c0-1.654 1.345-3 3-3h88"
      />
      <path
        fill="#6E6E73"
        fill-opacity=".15"
        d="M184 143H99a4 4 0 0 1-4-4V40a4 4 0 0 1 4-4h85a5 5 0 0 1 5 5v97a5 5 0 0 1-5 5"
      />
      <path fill="#FFF" d="M99 134V33h82v81.585L161.586 134z" />
      <path fill="#CBCBD4" d="M182 32H98v103h64l20-20V32zm-2 2v80.171L161.171 133H100V34h80z" />
      <path fill="#FFF" d="M162 132.764V115h17.764l.548.274-18.038 18.038z" />
      <path fill="#CBCBD4" d="M180 114h-19v19l1 2 20-20-2-1zm-1.829 2L163 131.171V116h15.171z" />
      <path fill="#FFF" d="M123 38.5v-9c0-2.206 1.794-4 4-4h26c2.206 0 4 1.794 4 4v9h-34z" />
      <path
        fill="#CBCBD4"
        d="M153 24.5h-26a5 5 0 0 0-5 5v10h36v-10a5 5 0 0 0-5-5m0 2c1.654 0 3 1.345 3 3v8h-32v-8c0-1.655 1.346-3 3-3h26"
      />
      <path fill="#FFF" d="M133.5 29v-6c0-2.205 1.794-4 4-4h5c2.206 0 4 1.795 4 4v6h-13z" />
      <path
        fill="#CBCBD4"
        d="M142.5 18h-5a5 5 0 0 0-5 5v7h15v-7a5 5 0 0 0-5-5m0 2c1.654 0 3 1.345 3 3v5h-11v-5c0-1.655 1.346-3 3-3h5"
      />
      <g class="icon-check">
        <path
          fill="#FF7450"
          d="M141.5 104c-12.426 0-22.5-10.074-22.5-22.5S129.074 59 141.5 59 164 69.074 164 81.5 153.926 104 141.5 104z"
          opacity=".3"
        />
        <path
          stroke="#ED234B"
          stroke-linecap="round"
          stroke-width="2"
          d="M163.108 73.493c.581 2.07.892 4.252.892 6.507 0 13.254-10.745 24-24 24s-24-10.746-24-24c0-13.255 10.745-24 24-24 5.95 0 11.392 2.164 15.586 5.749"
        />
        <path stroke="#ED234B" stroke-linecap="round" stroke-width="2" d="M129.5 77L140 87.5l24.75-24.75" />
      </g>
      <g stroke="#CBCBD4" stroke-width="2">
        <path
          stroke-linejoin="round"
          d="M47.789 96.114a4.106 4.106 0 0 1-4.098 4.115 4.106 4.106 0 0 1-4.098-4.115A4.106 4.106 0 0 1 43.691 92a4.106 4.106 0 0 1 4.098 4.114z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M47.756 107.429H37c0-3.977 3.21-7.2 7.17-7.2a7.163 7.163 0 0 1 6.212 3.6"
        />
        <path stroke-linecap="round" d="M51.374 106.914h6.146M54.447 103.829V110" />
      </g>
      <g stroke="#CBCBD4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M63 57.5V62H51v-8h12" />
        <path d="M51 54l6 4 6-4" />
      </g>
      <g stroke="#FF7450" stroke-linecap="round" stroke-width="2" opacity=".3">
        <path d="M40 24h6M43 21v6" />
      </g>
      <g stroke="#FF7450" stroke-linecap="round" stroke-width="2" opacity=".3">
        <path d="M262 81h6M265 78v6" />
      </g>
      <g stroke="#FF7450" stroke-linecap="round" stroke-width="2" opacity=".3">
        <path d="M63 136h6M66 133v6" />
      </g>
      <g stroke="#CBCBD4" stroke-linecap="round" stroke-width="2">
        <path d="M12 85h6M15 82v6" />
      </g>
      <g stroke="#CBCBD4" stroke-linecap="round" stroke-width="2">
        <path d="M240 45h6M243 42v6" />
      </g>
      <g stroke="#FF7450" stroke-linecap="round" stroke-width="2" opacity=".3">
        <path d="M214 125h6M217 122v6" />
      </g>
      <g stroke="#FF7450" stroke-linecap="round" stroke-width="2" opacity=".3">
        <path d="M74 75h6M77 72v6" />
      </g>
      <g class="icon-pencil">
        <g transform="scale(-1 1) rotate(-15 -50.826 887.042)">
          <path
            fill="#CBCBD4"
            d="M4.002 2.15L2.535.2C2.27-.066 1.736-.067 1.47.197L.003 2.143v15.852L4 18.003V2.15z"
            mask="url(#b)"
          />
        </g>
        <path
          fill="#FFF"
          d="M207.374 107.962c1.362.363 2.752-.222 3.034-1.275l19.966-74.53-.278-8.906c-.21-1.036-1.165-1.643-2.001-1.867-.841-.225-1.98-.176-2.684.624l-4.698 7.584-19.966 74.53c-.129.48-.015 1.01.322 1.488.375.534.965.93 1.662 1.118l4.643 1.234z"
        />
        <path
          fill="#CBCBD4"
          d="M228.354 20.418c1.334.358 2.5 1.333 2.739 2.725l.285 9.13-20.004 74.673c-.428 1.6-2.344 2.491-4.257 1.983l-4.637-1.234-.008-.002c-1.908-.511-3.119-2.233-2.69-3.83l20.003-74.672 4.815-7.774c.907-1.093 2.415-1.358 3.754-.999m-.518 1.932c-.504-.135-1.214-.139-1.628.269l-4.567 7.374-19.928 74.387c-.12.448.412 1.15 1.281 1.383l4.637 1.233c.872.232 1.69-.115 1.811-.568l19.928-74.386-.27-8.66c-.154-.551-.765-.898-1.264-1.032"
        />
        <path
          fill="#FF7450"
          fill-opacity=".3"
          d="M204.13 105.005l19.237-71.807c.509-1.9.736-3.864.674-5.83l-.15-4.806.71-1.145a3.142 3.142 0 0 1 1.684-1.035l.608-2.27 1.922-1.506c.325-.186.84-.049 1.03.275l.913 2.259-.609 2.27c.48.46.826 1.045.944 1.733l.285 9.13-20.004 74.673c-.428 1.6-2.343 2.492-4.256 1.983l-4.638-1.234a4.165 4.165 0 0 1-1.268-.575c1.397-.088 2.59-.895 2.918-2.115"
        />
      </g>
      <g stroke="#CBCBD4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M256 126.5V140h-12v-20h12v3M244 123h12M244 135h12M249.5 137.5h1" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'mission-icon',
};
</script>

<style lang="scss">
.icon-pencil {
  transform-origin: right top;
  animation: write-pencil 2s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite alternate;

  @keyframes write-pencil {
    from {
      transform: translate(0) rotate(0);
    }
    to {
      transform: translate(-2rem, 2rem) rotate(5deg);
    }
  }
}
.icon-check {
  transform-origin: center center;
  animation: checking 0.4s ease-in-out forwards;

  @keyframes checking {
    from {
      opacity: 0;

      transform: scale(0);
    }
    to {
      opacity: 1;

      transform: scale(1);
    }
  }
}
</style>
